import {
    VIDFLEET_INFORMATION_OPEN_MODAL,
    VIDFLEET_INFORMATION_CLOSE_MODAL,
    VIDFLEET_INFORMATION_REQUEST,
    VIDFLEET_INFORMATION_RESULT,
    VIDFLEET_INFORMATION_SETTINGS_REQUEST,
    VIDFLEET_INFORMATION_SETTINGS_RESULT,
    VIDFLEET_GET_CLIP_TIME_RANGE_REQUEST,
    VIDFLEET_GET_CLIP_TIME_RANGE_RESULT,
} from "Redux/actionTypes";

export const vidfleetInformationOpenModal = (esn, id, timezone, companyId, clips) => ({
    type: VIDFLEET_INFORMATION_OPEN_MODAL,
    payload: {esn, id, timezone, companyId, clips}
});

export const vidfleetInformationCloseModal = () => ({
    type: VIDFLEET_INFORMATION_CLOSE_MODAL
});

export const vidfleetInformationRequest = (esn) => ({
    type: VIDFLEET_INFORMATION_REQUEST,
    payload: { esn }
});

export const vidfleetInformationResult = (result) => ({
    type: VIDFLEET_INFORMATION_RESULT,
    payload: result
});

export const vidfleetInformationSettingsRequest = (esn) => ({
    type: VIDFLEET_INFORMATION_SETTINGS_REQUEST,
    payload: { esn }
});

export const vidfleetInformationSettingsResult = (result) => ({
    type: VIDFLEET_INFORMATION_SETTINGS_RESULT,
    payload: result
});

export const vidfleetGetClipTimeRequest = (esn, id, preloaded) => ({
    type: VIDFLEET_GET_CLIP_TIME_RANGE_REQUEST,
    payload: { esn, id, preloaded }
});

export const vidfleetGetClipTimeResult = (result) => ({
    type: VIDFLEET_GET_CLIP_TIME_RANGE_RESULT,
    payload: result
});